import React from 'react';
import { Link } from 'react-router-dom';
import { company } from '../data/site';
import './sections.css';

interface CtaBandProps {
    title: string;
    description: string;
    primaryLabel?: string;
    primaryTo?: string;
}

const CtaBand: React.FC<CtaBandProps> = ({
    title,
    description,
    primaryLabel = 'Talk to our team',
    primaryTo = '/contact',
}) => (
    <section className="cta-band">
        <div className="glow cta-band__glow" />
        <div className="container cta-band__inner">
            <div data-reveal="left">
                <h2>{title}</h2>
                <p className="lede">{description}</p>
            </div>
            <div className="btn-row cta-band__actions" data-reveal="right">
                <Link className="btn btn--primary btn--lg" to={primaryTo}>
                    {primaryLabel}
                </Link>
                <a
                    className="btn btn--ghost-dark btn--lg"
                    href={company.social.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    WhatsApp us
                </a>
            </div>
        </div>
    </section>
);

export default CtaBand;
